module.exports = __webpack_public_path__ + "static/media/checkout-page.f23e9f8b.png";